module.exports = __webpack_public_path__ + "img/logo_2.21936013.png";